import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoading = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_20592_586929)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M14.25 3.75L12 6M3.75 14.25L6 12",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.4246 8.99884H13.2426M1.57538 8.99884H4.75736",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.25 14.25L12 12M3.75 3.75L6 6",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.9997 16.4246L8.9997 13.2426M8.9997 1.57538L8.9997 4.75736",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeLinecap: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_20592_586929",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 18,
				height: 18,
				fill: "currentColor"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLoading);
export { ForwardRef as ReactComponent };
